module.exports = __webpack_public_path__ + "img/myaccount.c2076809.png";